import React, { useState } from 'react';
import { AutoComplete, Button, Space, Modal, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTheme } from '../../../contexts/ThemeContext';

const EditableSelect = ({
  value,
  onChange,
  options = [],
  placeholder = 'Selecione ou digite...',
  style,
  disabled = false,
  className,
  size = 'middle',
  onCreateNew,
  onSelect
}) => {
  const { theme } = useTheme();
  const [inputValue, setInputValue] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [newItemName, setNewItemName] = useState('');

  // Converter options para formato correto do AutoComplete
  const autoCompleteOptions = options.map(option => {
    if (typeof option === 'string') {
      return { value: option, label: option };
    }
    return { value: option.value, label: option.label };
  });



  const handleCreateNew = async () => {
    if (!newItemName.trim()) return;
    
    setIsCreating(true);
    try {
      const newId = await onCreateNew(newItemName.trim());
      if (newId) {
        setModalVisible(false);
        setNewItemName('');
        // Limpar o input do AutoComplete
        setInputValue('');
      }
    } catch (error) {
      console.error('Erro ao criar novo item:', error);
    } finally {
      setIsCreating(false);
    }
  };

  const handleSelect = (selectedValue, option) => {
    // Seleção normal
    setInputValue(''); // Limpar input após seleção
    if (onSelect) {
      onSelect(selectedValue, option);
    }
    if (onChange) {
      onChange(selectedValue);
    }
  };

  const handleChange = (newValue) => {
    setInputValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  // Encontrar o label do valor selecionado
  const selectedOption = autoCompleteOptions.find(option => option.value === value);
  const displayValue = selectedOption ? selectedOption.label : inputValue;



 

  return (
    <>
      <div style={{ position: 'relative', width: '100%' }}>
        <AutoComplete
          style={{ ...style, width: '100%' }}
          className={className}
          value={displayValue}
          onChange={handleChange}
          onSelect={handleSelect}
          options={options}
          placeholder={placeholder}
          disabled={disabled || isCreating}
          size={size}
          onClear={() => setInputValue('') || onChange('')}
          filterOption={(inputValue, option) => {
            // Se não há input ativo (usuário não está digitando), mostrar todas as opções
            if (!inputValue || inputValue === displayValue) return true;
            // Se há input ativo, filtrar normalmente
            return option.label.toLowerCase().includes(inputValue.toLowerCase());
          }}
        />
        {onCreateNew && (
          <div
            style={{
              position: 'absolute',
              right: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
              pointerEvents: 'auto'
            }}
          >
            <PlusOutlined
              style={{ 
                color: theme.primary, 
                cursor: 'pointer',
                fontSize: '14px',
                padding: '4px'
              }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setModalVisible(true);
              }}
            />
          </div>
        )}
      </div>

      <Modal
        title="Criar Novo Executivo"
        open={modalVisible}
        onOk={handleCreateNew}
        onCancel={() => {
          setModalVisible(false);
          setNewItemName('');
        }}
        confirmLoading={isCreating}
        okText="Criar"
        centered
        cancelText="Cancelar"
        width={400}
      >
        <Input
          placeholder="Digite o nome do executivo"
          value={newItemName}
          onChange={(e) => setNewItemName(e.target.value)}
          onPressEnter={handleCreateNew}
          autoFocus
        />
      </Modal>
    </>
  );
};

export default EditableSelect; 